export default {"src":"/_next/static/media/vendor-finance-home.3055d960.svg","height":36,"width":32};